import { Directive } from '@angular/core';

@Directive({
    selector: '[appCustomTableFilter]',
    standalone: false
})
export class CustomTableFilterDirective {

  constructor() { }

}
